export default "__VITE_ASSET__321375a5__"